<template>
    <filters-and-pagination
        :pagination-data="filtersAndPaginationData"
        :filterable-fields="filterFields"
        :loading-data="loadingFiltersAndPaginationData"
    >
        <leads-data-table :leads="filtersAndPaginationData.data" />
    </filters-and-pagination>
</template>

<script>
import FiltersAndPagination from "../filters-and-pagination/FiltersAndPagination";
import LeadsDataTable from "./components/LeadsDataTable.vue";
import {onMounted, toRef} from "vue";
import useFiltersAndPagination from '../../../state/common/filters-and-pagination'
import useTranslationSettings from '../../../state/portal/portal-translation-settings'
import useRecentActivities from "../../../composables/common/filter-and-pagination-data";

export default {
    name: "LeadsIndex",
    components: {
        FiltersAndPagination,
        LeadsDataTable
    },
    props: {
        options: {
            type: Object
        },
        filterFields: {
            type: Object
        },
        partnerProgramActivitiesUrl: {
            type: String
        },
        portalTranslationSettings: {
            type: [Object, Array, null]
        }
    },
    setup(props) {
        const options = props.options
        const partnerActivitiesUrl = props.partnerProgramActivitiesUrl
        const filterFields = toRef(props, 'filterFields')
        const { getFiltersAndPaginationData, loadingFiltersAndPaginationData, filtersAndPaginationData } = useRecentActivities()
        const { setLayoutOptions, setDataBaseUrl, setFetchDataFunction } = useFiltersAndPagination()
        const { setPortalTranslationSettings } = useTranslationSettings()

        onMounted( () => {
            setDataBaseUrl(partnerActivitiesUrl)
            setLayoutOptions(options)
            setFetchDataFunction(getFiltersAndPaginationData)
            setPortalTranslationSettings(props.portalTranslationSettings)
        })

        return {
            loadingFiltersAndPaginationData,
            filtersAndPaginationData,
            filterFields
        }
    }
}
</script>
